import { FC } from 'react';
import { Box, Flex, Link, Text, LegacyText } from 'flicket-ui';
import {
  BottomBar,
  ContentContainer,
  Icon,
  Layout,
  Menu,
  SubHeader,
  Footer,
} from '~components/common';
import { MobileMenu } from './mobileMenu';
import { ShoppingCart } from './shoppingCart';

interface MerchandiseLayoutProps {
  title: string;
  type?: 'primary' | 'secondary';
}

export const MerchandiseLayout: FC<MerchandiseLayoutProps> = ({
  children,
  title,
  type = 'primary',
}) => {
  return (
    <>
      <Menu>
        <SubHeader>
          <LegacyText
            fontSize={7}
            lineHeight="medium"
            fontWeight="heavy"
            color="white"
            variant="capitalize"
          >
            {title}
          </LegacyText>
          <Box>
            <ShoppingCart type={type} />
          </Box>
        </SubHeader>
      </Menu>
      <Flex
        pt={{ _: type === 'secondary' ? 0 : ('128px' as any), md: 0 }}
        flexDirection="column"
        width="100%"
        flex={1}
      >
        {type === 'secondary' && (
          <Box d={{ _: 'block', md: 'none' }}>
            <Box
              zIndex="banner"
              position="fixed"
              left="0"
              top="0"
              w="100%"
              bg="white"
            >
              <MobileMenu title={title} type={type} />
            </Box>
            {/* dummy menu so that the container changes height based on the content */}
            <Box>
              <MobileMenu title={title} type={type} />
            </Box>
          </Box>
        )}
        <Layout
          layoutType="overlay"
          flex={1}
          overflowY={{ _: 'auto', md: 'visible' }}
        >
          <ContentContainer variant="content">
            <Flex
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              maxWidth="1248px"
              mx={'auto' as any}
              px={4}
              mb={4}
              d={{ _: 'none !important', md: 'flex !important' }}
            >
              <Box>
                {type === 'secondary' && (
                  <Link to="/merchandise" linkAs="/merchandise">
                    <Flex fontSize={3} color="white" alignItems="center">
                      <Icon icon="chevron-left" />
                      <LegacyText fontWeight="extraBold">Back to merchandise</LegacyText>
                    </Flex>
                  </Link>
                )}
                <LegacyText
                  color="white"
                  fontWeight="heavy"
                  fontSize={9}
                  lineHeight={'56px' as any}
                >
                  {title}
                </LegacyText>
              </Box>
              <Box>
                <ShoppingCart type={type} />
              </Box>
            </Flex>
            {/* <Container mb={{ _: 8, md: 10 }}>{children}</Container>
            <Footer /> */}
            {children}
            <Footer />
          </ContentContainer>
        </Layout>
      </Flex>
      <BottomBar />
    </>
  );
};
